import { coreApi as api } from "../core/BaseApi";
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    getApiDashboardWidgets: build.query<
      GetApiDashboardWidgetsApiResponse,
      GetApiDashboardWidgetsApiArg
    >({
      query: () => ({ url: `/api/Dashboard/widgets` }),
    }),
    getApiDashboardLayout: build.query<
      GetApiDashboardLayoutApiResponse,
      GetApiDashboardLayoutApiArg
    >({
      query: (queryArg) => ({
        url: `/api/Dashboard/layout`,
        params: { companyId: queryArg.companyId, role: queryArg.role },
      }),
    }),
    postApiDashboardLayout: build.mutation<
      PostApiDashboardLayoutApiResponse,
      PostApiDashboardLayoutApiArg
    >({
      query: (queryArg) => ({
        url: `/api/Dashboard/layout`,
        method: "POST",
        body: queryArg.dashboardLayout,
      }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as enhancedApi };
export type GetApiDashboardWidgetsApiResponse = unknown;
export type GetApiDashboardWidgetsApiArg = void;
export type GetApiDashboardLayoutApiResponse = unknown;
export type GetApiDashboardLayoutApiArg = {
  companyId?: string;
  role?: string;
};
export type PostApiDashboardLayoutApiResponse = unknown;
export type PostApiDashboardLayoutApiArg = {
  dashboardLayout: DashboardLayout;
};
export type WidgetPlacement = {
  row?: number;
  col?: number;
  widgetId?: string;
};
export type DashboardLayout = {
  id?: string;
  companyId?: string;
  role?: string | null;
  grid?: WidgetPlacement[] | null;
  updatedAt?: string;
  layoutKey?: string | null;
};
export const {
  useGetApiDashboardWidgetsQuery,
  useLazyGetApiDashboardWidgetsQuery,
  useGetApiDashboardLayoutQuery,
  useLazyGetApiDashboardLayoutQuery,
  usePostApiDashboardLayoutMutation,
} = injectedRtkApi;
